import { render, staticRenderFns } from "./RoleMatrixTable.vue?vue&type=template&id=e7ce73f6&scoped=true"
import script from "./RoleMatrixTable.vue?vue&type=script&lang=js"
export * from "./RoleMatrixTable.vue?vue&type=script&lang=js"
import style0 from "./RoleMatrixTable.vue?vue&type=style&index=0&id=e7ce73f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ce73f6",
  null
  
)

export default component.exports